import React from 'react';
import './EmptyCard.scss';

interface IProps {
  text: string;
}

export const EmptyCard = (props: IProps) => {
  const { text } = props;

  return <div className="empty-container">{text}</div>;
};
